import axios from "axios";
import API_BASE_URL from "../config/apiConfig";
import HomepageData from "../Data/HomepageData.json";

const HOMEPAGE_REQUIRED_KEYS = [
  "title",
  "subTitle",
  "des",
  "subDesc",
  "buttonTitle",
  "technology",
  "about",
  "services",
  "offerings",
  "workPortfolio",
  "processmanagement",
  "why",
  "casestudy",
  "blog",
  "testimonials",
];

export const validateHomepageJson = (data) => {
  if (!data || typeof data !== "object") {
    return "Invalid JSON: expected an object.";
  }

  const missingKeys = HOMEPAGE_REQUIRED_KEYS.filter((key) => !(key in data));
  if (missingKeys.length) {
    return `Missing required keys: ${missingKeys.join(", ")}`;
  }

  return null;
};

export const fetchHomepageData = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/homepage-data`, {
      timeout: 5000,
    });

    if (response.data?.data) {
      return response.data.data;
    }

    throw new Error("Invalid homepage API response");
  } catch (error) {
    console.warn(
      "Homepage API unavailable, using local JSON fallback:",
      error.message,
    );
    return HomepageData;
  }
};

export const uploadHomepageData = async (homepageJson, accessToken) => {
  const validationError = validateHomepageJson(homepageJson);
  if (validationError) {
    throw new Error(validationError);
  }

  const response = await axios.post(
    `${API_BASE_URL}/homepage-data/upload`,
    homepageJson,
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    },
  );

  return response.data;
};
